/**
 * Payment account information for transfers (InstaPay, Vodafone Cash, etc.)
 */
export const PAYMENT_ACCOUNTS = {
    vodafoneCash: {
        id: 'vodafone_cash',
        number: '01016562330',
        nameAr: 'فودافون كاش',
        nameEn: 'Vodafone Cash',
        icon: '📱',
    },
    instaPay: {
        id: 'instapay',
        number: '01273224384',
        nameAr: 'إنستاباي',
        nameEn: 'InstaPay',
        recipientName: 'ناصر خضري عليوه',
        icon: '💳',
    },
} as const;
